import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const produtoReducer = (state = InitialState.produtoReducer, action) => {
    switch (action.type) {
        case ActionType.GET_PRODUTO_RESPONSE: {
            return {
                ...state,
                produtoObject: _.assign(action.produtoObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default produtoReducer;